<template>
  <div :class="featured ? 'article__featured-article' : 'article__column'">
    <div v-if="featured" class="article__preview">
      <a v-if="article.image" class="article-preview__image-wrapper" :href="article.url">
        <img class="article-preview__image" :src="imageSize(article.image, '720x433')" :alt="article.img_alt" />
      </a>
      <div class="article-preview__wrapper">
        <div class="article-preview__content">
          <p class="article-preview__blog preheader">{{ article.category }}</p>
          <h1 class="article-preview__title h5">{{ article.title }}</h1>
          <div class="article-preview__excerpt">
            <p class="body-md">{{ article.excerpt }}</p>
          </div>
          <div class="article-preview__meta-info">
            {{ article.published_at }}<span v-if="article.read_time"> - {{ article.read_time }} min read </span>
          </div>
          <v-link class="article-preview__read-more body-sm-mobile" primary :href="article.url">Read More</v-link>
        </div>
      </div>
    </div>
    <div v-else class="article__columns">
      <a v-if="article.image" class="article-preview__image-wrapper" :href="article.url">
        <img class="article-preview__image" :src="imageSize(article.image, '372x244')" :alt="article.img_alt" />
      </a>
      <div class="article-preview__content">
        <p class="article-preview__blog preheader">{{ article.category }}</p>
        <h2 class="article-preview__title h6-mobile h6-tablet-up">{{ article.title }}</h2>
        <div class="article-preview__excerpt">
          <p class="body-sm-mobile body-md-tablet-up">{{ truncate100(article.excerpt) }}</p>
        </div>
        <div class="article-preview__meta-info">
          {{ article.published_at }}<span v-if="article.read_time"> - {{ article.read_time }} min read </span>
          <!-- <p v-if="article.author">Written by <a :href="article.author_page" class="author_name" >{{article.author}}</a></p> -->
        </div>
        <v-link class="article-preview__read-more body-sm-mobile" secondary :href="article.url">Read &amp; Shop</v-link>
      </div>
    </div>
  </div>
</template>

<script>
import VLink from '@/scripts/components/buttons/VLink.vue';
import { truncateEllipsis, imageSize } from '@/scripts/helpers/util';

export default {
  name: 'BlogArticle',
  components: { VLink },
  props: {
    article: Object,
    featured: Boolean,
  },
  methods: {
    imageSize,
    truncate100: truncateEllipsis(100),
  },
};
</script>
<style >
  .author_name{
    text-decoration: underline;
    color: #3a3f28;
    font-weight: 400;
  }
</style>